// libs
import { useState, useEffect, useCallback } from 'react';

// def
import { IInputProps, ReqElement } from './types';

type PartialInputProps = Pick<
  IInputProps,
  'autoFocus' | 'isError' | 'value' | 'onFocus' | 'onBlur'
>;
interface IUseHelperProps extends PartialInputProps {
  hasPrefixComponent: boolean;
  hasSuffixComponent: boolean;
  autoFocus: boolean;
}
const useHelper = ({
  hasPrefixComponent,
  hasSuffixComponent,
  value,
  onFocus,
  isError,
  autoFocus,
  onBlur,
}: IUseHelperProps) => {
  const [inFocus, setInFocus] = useState(autoFocus);
  const [isValid, setValid] = useState(hasPrefixComponent || hasSuffixComponent || value !== '');

  const setFocus = useCallback(
    (event: React.FocusEvent<ReqElement>) => {
      setValid(false);
      setInFocus(true);
      onFocus && onFocus(event);
    },
    [onFocus]
  );

  const setOutOfFocus = useCallback(
    (event: React.FocusEvent<ReqElement>) => {
      const hasSomeValue = event.target.value !== '' || hasPrefixComponent || hasSuffixComponent;

      setValid(hasSomeValue);
      setInFocus(false);
      onBlur && onBlur(event);
    },
    [hasPrefixComponent, hasSuffixComponent, onBlur]
  );

  // setting initial values
  useEffect(() => {
    if (value !== '' || hasPrefixComponent || hasSuffixComponent) {
      setValid(true);
    }
  }, [hasPrefixComponent, hasSuffixComponent, value]);

  const barClassName = ['bar', isError && 'isError', inFocus && 'inFocus', isValid && 'isValid']
    .filter(Boolean)
    .join(' ');

  return { barClassName, inFocus, isValid, setFocus, setOutOfFocus };
};

export default useHelper;
